import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
type SolutionItem = {
  title: string;
  image: string;
  icon: JSX.Element;
  route: string;
  sectionId: string;
};

type SolutionsCarouselProps = {
  solutions: SolutionItem[];
  currentSectionId?: string;
};

const PrevArrow = ({ onClick }: { onClick?: () => void }) => (
  <button type="button" className="custom-carousel-arrow custom-carousel-arrow--prev" onClick={onClick} aria-label="Ver soluções anteriores">
    ‹
  </button>
);

const NextArrow = ({ onClick }: { onClick?: () => void }) => (
  <button type="button" className="custom-carousel-arrow custom-carousel-arrow--next" onClick={onClick} aria-label="Ver próximas soluções">
    ›
  </button>
);

const SolutionsCarousel = ({ solutions, currentSectionId }: SolutionsCarouselProps) => {
  const navigate = useNavigate();
  const filteredSolutions = currentSectionId
    ? solutions.filter((item) => item.sectionId !== currentSectionId)
    : solutions;

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    autoplay: true,
    autoplaySpeed: 3500,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className="main-solutions__carousel-shell">
      <div className="main-solutions__carousel">
        <Slider {...settings}>
          {filteredSolutions.map((item) => (
            <div key={item.title} className="solutions-carousel__slide">
              <div className="solutions-carousel__item">
                <img
                  className="solutions-carousel__image"
                  src={item.image}
                  alt={item.title}
                />

                <div className="solutions-carousel__card">
                  <div className="solutions-carousel__icon-wrapper">{item.icon}</div>
                  <h3>{item.title}</h3>
                  <button
                    type="button"
                    className="solutions-carousel__button"
                    onClick={() => navigate(`${item.route}#${item.sectionId}`)}
                  >
                    Saiba mais
                  </button>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default SolutionsCarousel;
